import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';
import { BI_BASE_URL } from '@app/contstants/endpoints';

interface ISourceFilter {
  name: string;
}

export const fetchData = async (): Promise<ISelectOption[]> => {
  const response = await api.get<ISourceFilter[]>(`${BI_BASE_URL}/helpers/search/sources/`);
  const data = response.data ?? [];

  return data.map(item => ({
    value: `${item.name}`,
    label: item.name,
  }));
};

export const useSourceOptions = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetchData,
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
